import { Button } from 'components/shared/Button';
import styled from 'styled-components';
import { container, fontSize, screen, spacing } from '../../theme';

export const StyledIntro = styled.section`
  text-align: center;
  max-width: ${container('lg')};
  margin: 0 auto ${spacing('xl6')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }

  ${Button} {
    margin-top: ${spacing('md')};
  }
`;

export const StyledImage = styled.img`
  display: block;
  margin: -${spacing('xl3')} auto ${spacing('xl4')};
`;
